<template>
<v-dialog
  :value="showDlgDelete"
  persistent
  @close="cancel"
  max-width="500"
  :content-class="'ModalSuccesDelete'"
>
  <v-card class="ModalSuccesDelete__card d-flex flex-column px-6 py-8">
    <div class="ModalSuccesDelete__close d-flex justify-end">
      <v-btn
        small
        @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <div class="ModalSuccesDelete__title">
      <span v-if="successText">
        {{successText}}
      </span>
      <span v-else>
        Баннер успешно удален
      </span>
    </div>

    <div class="ModalSuccesDelete__body">
      <v-img
        src="@/assets/images/adminPanel/success.webp"
        max-width="86px"
        :class="'BannerPreview__img'"
      />
    </div>
  </v-card>
</v-dialog>
</template>

<script>

/**
 * Компонент: ModalSuccesDelete
 * Описание:
 */
export default {
  name: 'ModalSuccessDelete',

  components: { },

  props: {
    showDlgDelete: {
      type: Boolean,
      default: false
    },
    successText: {
      type: String,
      default: '',
    }
  },
  emits: ['closeModal'],

  data() {
    return {};
  },

  computed: {},

  watch: {},

  created() {
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {
    cancel() {
      this.$emit('closeModal');
    }
  },
};
</script>

<style scoped lang="scss">
.ModalSuccesDelete{
  &__card{
    border-radius: 20px !important;
    box-shadow: none !important;
    gap: 24px;
  }

  &__close{
    & > button{
      box-shadow: none !important;
      background: transparent;
    }
  }

  &__title {
    font-size: 22px;
    color: var(--color-blue-500);
    font-weight: 600;
    text-align: center;
  }

  &__btn-group{
    display: flex;
    justify-content: center;
  }

  &__body{
    text-align: center;
    display: flex;
    justify-content: center;
  }

}
</style>
